import styled from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';

const S = {};

S.Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

S.Board = styled.div`
  flex: 1;
  display: flex;
  padding: ${theme('spacing.lg')};
  background-color: ${palette('bgBody')};
  overflow-x: auto;
  overflow-y: ${ifProp('scroll', 'auto', 'hidden')};
`;

S.BoardWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
`;

export default S;
